import type { AccentHue } from "@repo/fika-design-system/color"
import { Show } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Text } from "@/designSystem/components/text"
import type { HighlightPiece } from "@/lib/search-highlight"
import { Icon } from "../components/icon"
import { Mark } from "../components/mark"

type Props = {
  pieces: HighlightPiece[]
  hue: AccentHue
}
export function Quote(props: Props) {
  return (
    <Show when={props.pieces.length}>
      <Box
        background="sand100"
        borderRadius="s"
        padding={{ block: "8", inline: "12" }}
        flexDirection="row"
        alignItems="center"
        gap="12"
      >
        <div>
          <Icon name="quote" color="sand600" />
        </div>
        <Text fontSize="s" color="sand700">
          <Mark hue={props.hue} pieces={props.pieces} />
        </Text>
      </Box>
    </Show>
  )
}
